export class MessageCreationDto {
  content: string;
  type: string;
}
